import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Grid, Col, Row,} from 'react-bootstrap'
import {connect} from 'react-redux';

import _ from 'lodash'
import moment from "moment";
import AnnuityPaymentReport from "../MembersReports/components/AnnuityPaymentReport/AnnuityPaymentReport";

class PaymentsReports extends Component {
    static contextTypes = {api: PropTypes.object};

    constructor(props, context) {
    super(props);
        context.api.people.get(0, 200, '', {'membership.type': 'Miembro fundador'}, 'founderMembers')
        this.state = {
            yearMembership: moment().year(),
            yearIHS: moment().year()
        };
    }

    getFormValue = (name) => {
        return this.state[name] ? this.state[name] : '';
    };

    onFormChange = ({target}) => {
        this.setState({...this.state, [target.name]: target.value});
    };


    loadData = (tableState) => {
        this.tableState = tableState;
        if (tableState.filters.tags) tableState.filters['mailerTags.name'] = tableState.filters.tags;

        const filters = {...tableState.filters, 'order[name]': 'DESC'};
        this.context.api.emailAddresses.get(tableState.page, tableState.pageSize, '@Class.EmailAddresses.emailAddresses.get', filters)
    };

    debouncedLoadData = _.debounce(this.loadData, 500);

    render() {
        return (
            <div className="container-fluid PaymentsReports">
                <Grid fluid>
                    <Row>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <AnnuityPaymentReport title="Anualidades AMCEMIG pagadas por año" type={"membership"} />
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <AnnuityPaymentReport title="Anualidades IHS pagadas por año" type={"ihs"} />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = ({api: {founderMembers = [], founderMembersMeta = {}}}) => {
    return {founderMembers, founderMembersMeta}
};

export default connect(mapStateToProps)(PaymentsReports);

/**
const availableYears = ()=>{
    const initial  = 2018;
    const actual = moment().year();

    const years = [];
    for( let i=initial; i<=actual+3; i++) years.push( i );

    return years;
};
 */


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/Reports/PaymentsReports/index.jsx